import { useInfiniteQuery } from '@tanstack/react-query';

import { RequestsFilters } from '@carers/views/Requests/models/RequestsFilters';
import requestQueries from '@carers/views/Requests/utils/requestQueryFactory';

const useFetchRequests = (filters: RequestsFilters) =>
  useInfiniteQuery(requestQueries.list(filters));

export default useFetchRequests;
